/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import React                                  from 'react';
import { Colours }                            from "../../../styles/variables";
import styled, { keyframes }                  from 'styled-components';
import { StyledAnimatedScrollDownHybridPage } from "../../atoms/StyledAnimatedScrollDownHybridPage";


/*********************************************************************************
 2. Component
 *********************************************************************************/

const scroll = keyframes`
  0% {
    opacity: 0;
  }
  10% {
    transform: translateY(0);
    opacity: 1;
  }
  95% {
    transform: translateY(6px);
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;

const Mouse = styled.div`
  width: 3px;
  padding: 9px 10px;
  height: 20px;
  border: 2px solid ${Colours.White};
  border-radius: 25px;
  box-sizing: content-box;
`;

const Wheel = styled.div`
  width: 3px;
  height: 7px;
  border-radius: 25%;
  background-color: ${Colours.White};
  animation: ${scroll} 1700ms cubic-bezier(.15,.41,.69,.94) infinite;
`;

export const AnimatedScrollDown = ({ exact, to, target, children, onAnchorClick }) => (
    <StyledAnimatedScrollDownHybridPage>
        <Mouse>
            <Wheel/>
        </Mouse>
    </StyledAnimatedScrollDownHybridPage>
);



// WEBPACK FOOTER //
// ./src/components/molecules/AnimatedScrollDown/index.js